import { render } from "./dashCreateWorkView.vue?vue&type=template&id=fe0fc474"
import script from "./dashCreateWorkView.vue?vue&type=script&lang=js"
export * from "./dashCreateWorkView.vue?vue&type=script&lang=js"

import "./dashCreateWorkView.vue?vue&type=style&index=0&id=fe0fc474&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__